export default __webpack_public_path__ + "static/media/export.fcd763c3.svg";